export const fallbackLng = 'en';
export const languages = ['fa', 'ar', 'en'];
export const cookieName = 'i18next';

// ----------------------------------------------------------------------

export function i18nOptions(lng = fallbackLng) {
  return {
    // debug: true,
    lng,
    fallbackLng,
    supportedLngs: languages,
  };
}

// ----------------------------------------------------------------------

export const changeLangMessages = {
  fa: {
    success: 'زبان تغییر کرد!',
    error: 'خطا در تغییر زبان!',
    loading: 'منتظر بمانید...',
  },
  ar: {
    success: 'تم تغيير اللغة!',
    error: 'خطأ في تغيير اللغة!',
    loading: 'جارٍ التحميل...',
  },
};
